import React from 'react'
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../Utils/_helpers";
import * as auth from "../modules/Auth/_redux/authRedux";
import { getAuthState, getPageFilters } from "../util/helpers";
import { TextWrap } from "../util/showmore";
import { TimeInput } from "./TimeInput";

export function isNumber(value) {
  const number = Number(value);
  return !isNaN(number);
}

export function formatTimeItem(value) {
  return `${value || ""}00`.substr(0, 2);
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: 37,
    backgroundColor: "#f3f6f9",
    borderRadius: "4px",
    border: "solid 1px #ccd6e3",
  },
  input: {
    padding: "6px 25px 6px 0px",
    marginLeft: 2,
    flex: 1,
    lineHeight: "2em",
    minWidth: "95%",
    maxWidth: "100%",
  },
  iconButton: {
    padding: 4,
    marginLeft: 2,
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
});

const useStylesMobile = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: 37,
    backgroundColor: "#f3f6f9",
    borderRadius: "4px",
    border: "solid 1px #ccd6e3",
  },
  input: {
    padding: "6px 7px 7px",
    marginLeft: 8,
    flex: 1,
    lineHeight: "2em",
  },
  iconButton: {
    padding: 8,
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
});

export const InputGroupFilter = (props) => {
  const listKey = props.filter_key;
  const dispatch = useDispatch();

  const [isCustom, setCustom] = useState(false);

  const onChange = (object, event) => {
    if (props.type === "single_select") {
      values.map((v, i) => {
        v.selected = false;
      });
      object.selected = event.target.checked;

      if (values) {
        values.map((v, i) => {
          if (v.value === "custom" && v.selected === true) {
            setCustom(true);
          } else if (v.value === "custom" && v.selected === false) {
            setCustom(false);
          }
        });
      }
    } else {
      object.selected = event.target.checked;
      if (object.value === "all") {
        values.map((v, i) => {
          v.selected = object.selected;
        });
      }

      if (object.value !== "all") {
        let allSelected = true;

        values.map((v, i) => {
          if (v.value !== "all" && !v.selected) allSelected = false;
        });

        values.map((v, i) => {
          if (v.value === "all") v.selected = allSelected;
        });
      }
    }

    let pageFilters = getPageFilters();
    pageFilters = { ...pageFilters };
    pageFilters[listKey] = [...values];

    var changelog = {};
    changelog[listKey] = [...values];
    pageFilters["changelog"] = changelog;

    const action = {
      type: auth.actionTypes.Set,
      payload: { ...pageFilters },
    };
    dispatch(action);
    dispatch(
      auth.actions.CheckFiltersState({
        apply: true,
        filter_type: props.filterState
          ? props.filterState
          : "callLogsFiltersState",
      })
    );
  };

  useEffect(() => {
    setSearchTerm("");
    setUiState("closed");
  }, [props.clearFilterFlag]);

  const values = useSelector((state) => {
    return state.auth[listKey];
  });

  useEffect(() => {
    if (values && listKey === "call_duration") {
      let found = false;
      values.map((v, i) => {
        if (v.value === "custom" && v.selected === true) {
          setCustom(true);
          found = true;
        }
      });
      if (!found) {
        setCustom(false);
      }
    }
  }, [values]);

  const sm = useStylesMobile();
  const lg = useStyles();
  const searchClasses = props.isMobile ? sm : lg;

  const [queryString, setQueryString] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setQueryString(searchTerm);
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  useEffect(() => {
    const apply = async () => {
      const response = await props.searchApi(queryString);
      if (response.data && response.data.objects) {
        let list = [];
        response.data.objects.map((c, i) => {
          if (
            props.filter_key !== "agent_names_call_logs_filter" &&
            props.filter_key !== "agent_names_crm_filter"
          ) {
            list.push({
              label: c.order_id,
              value: c.order_id,
              selected: false,
            });
          } else {
            let backup_number_string = c.backup_number
              ? "," + c.backup_number
              : false;
            list.push({
              label: c.first_name + " " + c.last_name,
              value: backup_number_string
                ? c.contact_number + backup_number_string
                : c.contact_number,
              selected: false,
            });
          }
        });

        let pageFilters = getPageFilters();
        pageFilters = { ...pageFilters };
        pageFilters[listKey] = [...list];

        var changelog = {};
        changelog[listKey] = [...list];
        pageFilters["changelog"] = changelog;

        const action = {
          type: auth.actionTypes.Set,
          payload: { ...pageFilters },
        };
        dispatch(action);
      }
    };

    if (props.search) {
      apply();
    }
  }, [queryString, props.search]);

  const [uiState, setUiState] = useState(
    props.initialOpen ? "opened" : "closed"
  );

  useEffect(() => {
    setSearchTerm("");
    setUiState("closed");
  }, [props.clearFilterFlag]);
  useEffect(() => {
    if (props.initialOpen) setUiState("opened");
  }, []);

  return (
    <>
      <ul className="list-unstyled p-5 mb-0">
        <li className="title mt-1">
          {uiState === "opened" && (
            <span className="mr-3">
              <img
                alt=""
                onClick={() => {
                  setUiState("closed");
                }}
                src={toAbsoluteUrl("/media/sr/icons/filter-minus.svg")}
              />
            </span>
          )}
          {uiState === "closed" && (
            <span className="mr-3">
              <img
                alt=""
                onClick={() => {
                  setUiState("opened");
                }}
                src={toAbsoluteUrl("/media/sr/icons/filter-plus.svg")}
              />
            </span>
          )}
          <span className="sub-filter-title">{props.filter_title}</span>
        </li>
        {uiState === "opened" && (
          <li>
            <ul className="pl-0 chid-cb-filters list-unstyled">
              {props.search && (
                <li className="mb-5 mt-5">
                  <Paper className={searchClasses.root} elevation={0}>
                    <IconButton
                      className={searchClasses.iconButton}
                      aria-label={props.searchPlaceholder}
                    >
                      <SearchIcon />
                    </IconButton>
                    <InputBase
                      className={searchClasses.input}
                      placeholder={"Search..."}
                      inputProps={{ "aria-label": "Search..." }}
                      value={searchTerm}
                      onChange={(event) => setSearchTerm(event.target.value)}
                    />
                  </Paper>
                </li>
              )}
              {values &&
                values.map((option, i) => (
                  <li key={i}>
                    <Form.Check key={i} type={"checkbox"}>
                      <Form.Check.Input
                        type={"checkbox"}
                        id={`default-${i}`}
                        onChange={(event) => {
                          onChange(option, event);
                        }}
                        checked={option.selected === true ? true : false}
                      />
                      <Form.Check.Label id={`default-${i}`}>
                        {listKey === "disposition" ? (
                          <TextWrap text={option.label} max={12} />
                        ) : (
                          option.label
                        )}
                      </Form.Check.Label>
                    </Form.Check>
                  </li>
                ))}
              {!values.length && "No Records"}
            </ul>
          </li>
        )}
        {uiState === "opened" && listKey === "call_duration" && (
          <li style={{ display: isCustom === true ? "block" : "none" }}>
            <TimeInput
              minKey="duration__lte_min_CallLogs"
              min={getAuthState().duration__lte_min_CallLogs}
              isCustom={isCustom}
              secKey="duration__lte_sec_CallLogs"
              sec={getAuthState().duration__lte_sec_CallLogs}
            />
          </li>
        )}
      </ul>
      <div className="filter-divider"></div>
    </>
  );
};
